import React from "react";
import formatAmount from "../../../../utils/FormetAmount.js";

const BalanceCard = ({
  type,
  amount,
  color = "bg-blue-500",
  gradient = "from-[#EFF6FF] to-[#ffff]",
  icon,
  className = "",
  innerClassName = "",
  titleClass = "",
  amountClass = "",
  onClick,
}) => {
  return (
    <div
      className={`rounded-2xl p-3 text-center shadow-md border border-white bg-gradient-to-tl ${gradient} ${className} ${
        onClick ? "cursor-pointer hover:shadow-lg transition-shadow" : ""
      }`}
      onClick={onClick}
    >
      <div className={`flex flex-col items-center gap-2 mb-2 ${innerClassName}`}>
        <div
          className={`p-2 ${color} rounded-[10px] flex items-center justify-center`}
        >
          {icon}
        </div>
        <div>
          <h3
            className={`text-xs font-bold text-gray-700 leading-5 ${titleClass}`}
          >
            {type}
          </h3>
        </div>
      </div>
      <p className={`text-sm  font-bold text-gray-900 ${amountClass}`}>
        ${formatAmount(amount || 0)}
      </p>
    </div>
  );
};

export default BalanceCard;
